import type { Paginated, SecretariaSummary } from '@obras/shared';
import { useQuery } from '@tanstack/react-query';

import { api } from '../../lib/api.js';

/**
 * As secretarias ativas, para o seletor do formulário de obra.
 *
 * Cache de cinco minutos, como o das empresas: a lista muda uma vez por
 * mandato, e recarregá-la a cada abertura do formulário seria requisição a
 * troco de nada.
 */
export function useSecretariaOptions() {
  return useQuery({
    queryKey: ['secretarias', 'options'],
    queryFn: ({ signal }) =>
      api.get<Paginated<SecretariaSummary>>('/secretarias?perPage=100&status=ativa', signal),
    staleTime: 5 * 60 * 1000,
  });
}
